module.exports = __webpack_public_path__ + "img/34.5c5bf9ff.png";